import React from "react";
import { HeroSection } from "./HeroSection";
import { EmpowerStatement } from "./EmpowerStatement";
import { FeatureCards } from "./FeatureCards";
import { WhyMinEMI } from "./WhyMinEMI";
import { JourneySections } from "./JourneySections";
import { ComparisonSection } from "./ComparisonSection";
import { NewsSection } from "./NewsSection";
import { LendingPartners } from "./LendingPartners";
import { Helmet } from "react-helmet-async";

export default function NewHomePage() {
  return (
    <div className="min-h-screen w-full">
      <Helmet>
        <title>Minemi AI – Smarter Loans, Faster Finance Solutions</title>
      </Helmet>
      <HeroSection />
      <EmpowerStatement />
      <FeatureCards />
      <WhyMinEMI />
      <JourneySections />
      <ComparisonSection />
      <NewsSection />
      <LendingPartners />
    </div>
  );
}
